import { findTagsInContent, replaceAll } from '@/system/helpers/index.js';

/**
 * Notes: this function handles both the conversion for old and new style tags, this means
 * everything is backwards compatible with content that doesn't use the new tag style.
 *
 * Old style = [tag]
 * New Style = @tag
 */
export default function replaceContentTags(content, tagReplacements = []) {
    tagReplacements = tagReplacements || [];
    content = _replaceNewTemplateTags(content, tagReplacements);
    content = _replaceOldTemplateTags(content, tagReplacements);

    return content;
};

/**
 * New style template tags that use @tag_name instead of [tag_name].
 */
function _replaceNewTemplateTags(templateContent, tagReplacements = []) {
    const tagsInTemplate = findTagsInContent(templateContent);

    // Convert the journal template string into an HTML doc, so we can process the new style <span> tags
    let templateContentDOM = new DOMParser();
    const templateHtmlDoc = templateContentDOM.parseFromString(templateContent, 'text/html');

    // All new style tags are located within span elements called feed tags
    let feedTags = templateHtmlDoc.getElementsByTagName('span');

    /*
      Process all the feed tags, find their
      values which they need to be replaced with and
      as they are part of a DOM document, we can directly
      replace them once we have the right tag value.
     */
    for (let feedTag of feedTags) {

        // The tag name (@tag_name) is stored inside an attribute called 'data-mention'
        let templateTagToReplace = feedTag.getAttribute('data-mention');

        // Only process span elements that have a 'data-mention' attribute
        if (templateTagToReplace === null) {
            continue;
        }

        // We can loop through global user tags to find the right value we need to replace our tag with...
        const newTagValueIndex = tagReplacements.findIndex((tag) => tag.newStyleTag === templateTagToReplace)

        // Skip a tag if it cannot be found, probably missing a translation...
        if (newTagValueIndex < 0) {
            continue;
        }

        // Recreate the span (so that it renders property in the editor again element and use the tags value
        let tagValue = document.createElement('span');
        tagValue.innerHTML = tagReplacements[newTagValueIndex].value;

        // Replace the span element with the tag value
        feedTag.parentNode.replaceChild(tagValue, feedTag);
    }

    // We just want to return the text content, the editor will do the rendering...
    return templateHtmlDoc.body.innerHTML;
}

/**
 * Responsible for converting old style tags ([name]) to
 * their values. This replies on searching for text and
 * replacing values that are found with the tags.
 */
function _replaceOldTemplateTags(templateContent, tagReplacements = []) {
    let content = templateContent;
    const tagsInTemplate = findTagsInContent(content);

    tagReplacements.forEach(entry => {
        // validate if [tag] exists and has a value
        if (tagsInTemplate.includes(entry.tag) && entry.value) {
            content = replaceAll(content, entry.tag, entry.value);
        }
    });

    return content;
}
